import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* cardPointAdvancedDataWatchers() {
  yield all([
    takeEvery(EntryActionTypes.CARD_POINT_ADVANCED_DATA_IN_CURRENT_CARD_FETCH, () =>
      services.fetchCardPointAdvancedDataInCurrentCard(),
    ),
    takeEvery(EntryActionTypes.CARD_POINT_ADVANCED_DATA_IN_CURRENT_CARD_CREATE, () =>
      services.createCardPointAdvancedDataInCurrentCard(),
    ),
    takeEvery(EntryActionTypes.CARD_POINT_ADVANCED_DATA_UPDATE, ({ payload: { id, data } }) =>
      services.updateCardPointAdvancedData(id, data),
    ),
    takeEvery(EntryActionTypes.CARD_POINT_ADVANCED_DATA_DELETE, ({ payload: { id } }) =>
      services.deleteCardPointAdvancedData(id),
    ),
  ]);
}

